<div class="content">
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 common_title">
          <h2>ADD - BREEDS MANAGEMENT</h2>
          <p>Create Breeds record</p>
          <a (click)="backnavigate()" class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i>
            Back
          </a>
        </div>
      </div>
      <form class="row bottomheight" [formGroup]="registerForm">
        <!--loader start-->
        <div class="loading-div" *ngIf="isLoading">
          <div class="loading-bar">
            <div class="lds-roller">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
            <p class="mt-3">Processing data. Please wait..</p>
          </div>
        </div>
        <!--loader end-->
        <div class="col-lg-4 col-md-6 col-sm-6 ">
          <div class="form-group multiple">
            <label for="Farm Name" class="farmmulti">Farm Name</label>
            <select multiple="multiple" name="farmname" id="farmname" class="form-control">
              <!--<option value="0" id="countries">Select All</option>-->
              <option *ngFor='let getfarms of getfarmsListData' [value]="getfarms.tnfr_id">{{getfarms.tnfr_name}}
              </option>
            </select>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 dropdowntop">
          <div class="form-group ">
            <label for="Species Name"><span class="dec">Species Name</span></label>
            <select id="speciesid" name="speciesid" title="select species"
              class="selectpicker form-control myFakeClass1" (change)="getspeciesvalue($event)">
              <option id="speciesoption" *ngFor='let specieslist of speciesloaddata'
                value="{{specieslist.id}} and {{specieslist.speciesID}}">{{specieslist.name}}</option>
            </select>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="breed Name">Breed Name</label>
            <input type="text" name="breedname" id="breedname" formControlName="breedname"
              class="form-control myFakeClass dropdown-toggle" data-toggle="dropdown"
              [ngClass]="{ 'is-invalid': submitted && f.breedname.errors }">
            <div *ngIf="submitted && f.breedname.errors" class="invalid-feedback">
              <div class="selectvalidate" *ngIf="f.breedname.errors.required">Breed Name must be filled out</div>
            </div>
          </div>
        </div>
        <!--<div class="col-lg-4 col-md-6 col-sm-6">
       <div class="form-group">
       <label for="Breed Name">Breed Name</label>
       <select class="selectpicker form-control">
       <option selected="selected">Breed Name</option>
       <option value="Red Sindhi">Red Sindhi</option>
       <option value="Red Sindhi">Red Sindhi</option>
       </select>
       </div>
       </div>-->
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="breed Name">Breed ID</label>
            <input type="text" name="breedid" id="breedid" formControlName="breedid" class="form-control"
              [ngClass]="{ 'is-invalid': submitted && f.breedid.errors }">
            <div *ngIf="submitted && f.breedid.errors" class="invalid-feedback">
              <div class="selectvalidate" *ngIf="f.breedid.errors.required">Breed ID must be filled out</div>
            </div>
          </div>
        </div>
        <!-- <div class="col-lg-4 col-md-6 col-sm-6">
       <div class="form-group">
       <label for="Breed ID">Family</label>
       <select class="selectpicker form-control">
       <option selected="selected">Bovidae</option>
       <option value="Bovidae">Bovidae</option>
       <option value="Bovidae">Bovidae</option>
       </select>
       </div>
       </div>-->

        <!--<div class="col-lg-4 col-md-6 col-sm-6">
        <label for="breed Name" >Species ID</label>
        <div class="form-group">
          <input type="text" name="speciesid" id="speciesid" value="" formControlName="speciesid" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.speciesid.errors }" >
          <div *ngIf="submitted && f.sp eciesid.errors" class="invalid-feedback">
            <div class="selectvalidate" *ngIf="f.speciesid.errors.required">Species ID must be filled out</div>
          </div>  
        </div>
       </div>-->

        <div class="col-lg-4 col-md-6 col-sm-6 dropdowntop">
          <div class="form-group">
            <label id="choose" for="Status"><span class="dec">Status</span></label>
            <select id="status" class="selectpicker form-control myFakeClass">
              <option value="1">Active</option>
              <option value="0">Inactive</option>
            </select>
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 text-center">
          <a (click)="onSubmit()" class="btn btn-fill btn-primary mb-3">Submit<div class="ripple-container"></div></a>
          <button (click)="backtobreeds()" class="btn btn-fill btn-default">Cancel<div class="ripple-container"></div>
            </button>
        </div>
      </form>
    </div>
  </div>
</div>